module.exports = __webpack_public_path__ + "static/house-main-a5035e05b3de9d3d72e96b0302e5f76c.jpg";